import { render, staticRenderFns } from "./EditNotifications.vue?vue&type=template&id=59a97894"
import script from "./EditNotifications.vue?vue&type=script&lang=js"
export * from "./EditNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports